export const corporate = {
  "hero": {
    "title": "O DONKEY TRAVEL",
    "subtitle": "Odkryj naszą historię, naszą wizję i pełen pasji zespół, który na nowo wymyśla wymianę domów dla najbardziej wymagających gospodarzy."
  },
  "mission": {
    "badge": "Nasza misja",
    "title": "Demokratyzacja podróży premium typu peer-to-peer",
    "description": "DONKEY TRAVEL powstał z prostą ambicją: aby najlepsi goście również mogli cieszyć się owocami swojej pracy. Wierzymy, że właściciele wyjątkowych domów o ocenie 4,5 i wyższej zasługują na dedykowaną platformę, na której mogą bezpiecznie handlować swoimi nieruchomościami, bez tarć finansowych związanych z tradycyjnym wynajmem."
  },
  "philosophy": {
    "badge": "Filozofia i wartości",
    "title": "W sercu naszego klubu",
    "description": "Nie jesteśmy tylko platformą, jesteśmy społecznością zbudowaną na zaufaniu, wzajemnym szacunku i doskonałej gościnności.",
    "values": {
      "fair": {
        "title": "Słuszność",
        "desc": "Nasz system transakcyjny został zaprojektowany tak, aby był uczciwy i przejrzysty. Oferujesz czas w swoim zakwaterowaniu, oszczędzasz czas na podróż. To proste, bez ukrytych opłat."
      },
      "local": {
        "title": "Zanurzenie",
        "desc": "Wymiana domu to możliwość życia jak miejscowy, odkrywania regionów na uboczu i tworzenia autentycznych połączeń."
      },
      "community": {
        "title": "Zaufanie",
        "desc": "Rezerwując nasz klub dla gości z oceną 4,5+, gwarantujemy nienaganny poziom wymagań i jakości w naszej sieci."
      }
    }
  },
  "team": {
    "badge": "Zespół",
    "title": "ZA PODRÓŻĄ OSŁA",
    "subtitle": "Platforma zrodzona z pasji do podróży i gościnności.",
    "members": {
      "ceo": {
        "name": "Sylvain",
        "role": "Założyciel i dyrektor generalny",
        "bio": "Sylvain, będący od lat gospodarzem z pasją, wyobraził sobie DONKEY TRAVEL, który sam szukał rozwiązania na bezpłatne podróżowanie, promując jednocześnie własne zakwaterowanie. Kierowany chęcią stworzenia najlepszego europejskiego klubu wymiany, każdego dnia dba o doskonałość społeczności."
      }
    }
  },
  "investors": {
    "badge": "Inwestorzy i partnerzy",
    "title": "Dołącz do przygody",
    "description": "DONKEY TRAVEL rozwija się i zawsze jesteśmy otwarci na strategiczne możliwości przyspieszenia naszego rozwoju w całej Europie.",
    "cta": "Skontaktuj się z nami"
  }
};
